// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// FRONT-END-ONLY SEED DATA (operator shift Log). New notes added at runtime
// live only in memory for the session. See docs/design/hardcoded-frontend-data.md.

import type { LogNote } from '../types/alarm';

export const LOG_NOTES: LogNote[] = [
  {
    id: 'log-1',
    t: '14:30',
    who: 'Marcus O.',
    asset: 'CH-2 Chiller',
    siteLabel: 'GA-10 Atlanta',
    text: 'Started CH-3 and failed Hall A loop over per SOP-CHL-017. CHW supply recovering toward 44 °F. Tech dispatched to condenser.',
  },
  {
    id: 'log-2',
    t: '13:10',
    who: 'Marcus O.',
    asset: 'UPS-2 Vertiv Liebert',
    siteLabel: 'GA-10 Atlanta',
    text: 'Confirmed UPS-1 online with headroom. Preparing to isolate Bank 2 string 3.',
  },
  {
    id: 'log-3',
    t: '11:05',
    who: 'C. Okafor',
    siteLabel: 'GA-10 Atlanta',
    text: 'Shift handover: all cooling nominal at start of day shift; watching CRAH-1 supply-air trend.',
  },
  {
    id: 'log-4',
    t: '09:20',
    who: 'Energy Fluo',
    asset: 'Transformer TX-3',
    siteLabel: 'GA-10 Atlanta',
    text: 'Auto-note: TX-3 standby load flagged (ALM-4453). Recommend restoring the affected circuit to its primary path.',
  },
];
